import ProgramQuestionMy from "@/views/Program/ProgramQuestionMy.vue";
import ProgramQuestionCreate from "@/views/Program/ProgramQuestionCreate.vue";
import ProgramQuestionMyDetail from "@/views/Program/ProgramQuestionMyDetail.vue";
export default [
  {
    path: "program",
    name: "Program",
    component: { render: h => h("router-view") },
    permission: "coding.api.jiker_fuwu_admin.questions.tasks.index",
    meta: {
      nav: {
        icon: "el-icon-s-platform",
        title: "编程题库"
      },
      breadcrumb: {
        title: "编程题库",
        replace: false
      }
    },
    children: [
      {
        path: "task",
        name: "programTaskSelf",
        redirect: { name: "programTaskList" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "programTaskList",
            component: () => import("@/views/Program/ProgramTaskList.vue"),
            permission: "coding.api.jiker_fuwu_admin.questions.tasks.index",
            meta: {
              title: "极客-编程题库-出题任务",
              nav: {
                title: "出题任务"
              },
              breadcrumb: {
                title: "出题任务",
                replace: false
              }
            }
          }
        ]
      },
      {
        path: "my",
        name: "ProgramQuestion",
        redirect: { name: "ProgramQuestionMy" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "ProgramQuestionMy",
            component: ProgramQuestionMy,
            permission: "coding.api.jiker_fuwu_admin.questions.my.index",
            meta: {
              title: "极客-编程题库-我的出题",
              nav: {
                title: "我的出题"
              },
              breadcrumb: {
                title: "我的出题",
                replace: false
              }
            }
          },
          {
            path: "detail/:uuid",
            name: "ProgramQuestionMyDetail",
            component: ProgramQuestionMyDetail,
            permission: "coding.api.jiker_fuwu_admin.questions.show",
            meta: {
              title: "极客-编程题库-题目详情",
              // nav: {
              //   title: "我的出题"
              // }
              breadcrumb: {
                title: "题目详情",
                replace: false
              }
            }
          }
        ]
      },
      {
        path: "create/:id",
        name: "ProgramQuestionCreate",
        component: ProgramQuestionCreate,
        permission: "coding.api.jiker_fuwu_admin.questions.store",
        meta: {
          title: "极客-编程出题",
          breadcrumb: {
            title: "编程出题",
            replace: false
          }
        }
      }
    ]
  }
];
